/* istanbul ignore file */
import { Button, Modal as ModalBootstrap, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { ReactElement } from "react";

import { ButtonVariant } from "react-bootstrap/esm/types";
import { DevDebug } from "../dev-debug/dev-debug";
import { ErrorBoundary } from "adviesbox-shared";

type ModalProps = {
  title?: string;
  body?: JSX.Element;
  closeModal?: () => void;
  onCancelClick?: () => void;
  onSubmitClick?: () => void;
  isSubmitting?: boolean;
  noEditableData?: boolean;
  modalIndex?: number;
  invalid?: boolean;
  tooltip?: string | ReactElement;
  saveButtonTekst?: string;
  cancelButtonTekst?: string;
  prependToFooter?: React.ReactNode;
  appendToFooter?: React.ReactNode;
  submitDisabled?: boolean;
  saveBtnVariant?: ButtonVariant;
};

const Modal = ({
  title,
  body,
  closeModal,
  onCancelClick,
  onSubmitClick,
  isSubmitting,
  noEditableData,
  tooltip,
  invalid = false,
  saveButtonTekst = "Bevestigen",
  cancelButtonTekst = "Annuleren",
  prependToFooter = <></>,
  appendToFooter = <></>,
  submitDisabled,
  saveBtnVariant = "primary"
}: ModalProps): ReactElement => {
  return (
    <>
      <ModalBootstrap.Header>
        <div className="d-flex w-100">
          <ModalBootstrap.Title>
            <>
              {title}
              {tooltip && (
                <OverlayTrigger
                  trigger="click"
                  key={`${title}_tooltip`}
                  rootClose={true}
                  placement="bottom"
                  overlay={<Tooltip id={`${title}-tooltip`}>{tooltip}</Tooltip>}
                >
                  <Button className="question-tip" id={`${title}-tooltip`} />
                </OverlayTrigger>
              )}
            </>
          </ModalBootstrap.Title>
          <button type="button" className={"close ml-auto"} onClick={() => { onCancelClick?.(); closeModal?.(); }} id={`btnClose-${title}`}>
            <span aria-hidden="true">×</span>
            <span className="sr-only">Close</span>
          </button>
        </div>
      </ModalBootstrap.Header>
      <ModalBootstrap.Body>
        <>
          <ErrorBoundary>
            <>{body}</>
          </ErrorBoundary>
        </>
        <DevDebug />
      </ModalBootstrap.Body>
      <ModalBootstrap.Footer>
        {!noEditableData && (
          <>
            {prependToFooter}
            <Button
              disabled={isSubmitting}
              id="btnannuleren"
              data-testid="btnannuleren"
              variant="link"
              onClick={() => { onCancelClick?.(); closeModal?.(); }}
            >
              {cancelButtonTekst}
            </Button>
            <Button
              disabled={invalid || isSubmitting || submitDisabled}
              id="btnopslaan"
              data-testid="btnopslaan"
              variant={saveBtnVariant}
              onClick={() => { onSubmitClick?.(); closeModal?.(); }}
            >
              {saveButtonTekst}
            </Button>
            {appendToFooter}
          </>
        )}
        {noEditableData && (
          <Button id="btnsluiten" data-testid="btnsluiten" variant="primary" onClick={() => { onCancelClick?.(); closeModal?.(); }}>
            Sluiten
          </Button>
        )}
      </ModalBootstrap.Footer>
    </>
  );
};

Modal.displayName = "Modal";

export default Modal;
